import Icon from "../Icon";

export enum IconColor {
  GRAY = "gray",
  WHITE = "white",
}

const InfoIcon = ({
  iconColor = IconColor.GRAY,
  styleProps,
}: {
  iconColor?: IconColor;
  styleProps?: object;
}) => (
  <Icon
    src={`/icons/info${iconColor == IconColor.GRAY ? "_gray" : "-white"}.svg`}
    alt="tooltip"
    iconDimension={16}
    styleProps={styleProps}
  />
);

export default InfoIcon;
